import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GuestForm from './guest/GuestForm';
import Courses from './pages/Courses';
import CourseAssessments from './pages/CourseAssessments';
import Question from './pages/Question';
import ResultPage from './pages/ResultPage';
import NotFound from './pages/NotFound';
import Header from './components/Header';
import Footer from './components/Footer';

export default function App() {
  return (
    <BrowserRouter basename="/practice-tests">
    {/* <BrowserRouter> */}
      <Header />
      <Routes>
        <Route path="/" element={<Courses />} />
        {/* when build for production hide course route because I don't show all course route*/}
        {/* <Route path="/all-courses" element={<Courses />} /> */}
        <Route path="/courses/:slug" element={<CourseAssessments />} />
        <Route path="/assessment/:slug/form" element={<GuestForm />} />
        <Route path="/:slug/questions/:q" element={<Question />} />
        <Route path="/assessment/:id/result" element={<ResultPage />} />
        {/* Catch-all route for unknown paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}
